<template>
    <div class="confirm_inputs">
        <input 
            v-for="item in 4" 
            :key="item" 
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="1"
            :value="displayValue(item - 1)"
            :class="code[(item - 1)] ? 'active' : ''"
            @keydown="handleKeyDown($event, (item - 1))"
            @input="handleInput($event, (item - 1))"
            @paste="handlePaste($event, (item - 1))"
            :ref="`confirm_input_${item - 1}`"
        >
    </div>
</template>

<script>
export default {
    name: "Identifiction",
    props: {
        confirmCode: String,
        masked: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:confirmCode"],
    data () {
        return {
            code: ['', '', '', '']
        }
    },
    watch: {
        confirmCode: {
            immediate: true,
            handler (value) {
                const normalizedCode = this.normalizeDigits(value).slice(0, 4);

                if (normalizedCode === this.code.join('')) {
                    return;
                }

                this.code = [
                    normalizedCode[0] || '',
                    normalizedCode[1] || '',
                    normalizedCode[2] || '',
                    normalizedCode[3] || '',
                ];
            }
        }
    },
    methods: {
        normalizeDigits (value) {
            return String(value || '').replace(/\D/g, '');
        },
        getInput (idx) {
            const inputRef = this.$refs[`confirm_input_${idx}`];
            return Array.isArray(inputRef) ? inputRef[0] : inputRef;
        },
        emitCode () {
            this.$emit('update:confirmCode', this.code.join(''));
        },
        displayValue (idx) {
            return this.masked && this.code[idx] ? '*' : this.code[idx];
        },
        focusInput (idx) {
            this.$nextTick(() => {
                const input = this.getInput(Math.max(0, Math.min(idx, 3)));
                input?.focus();
                input?.select();
            });
        },
        fillDigits (digits, startIdx) {
            const nextCode = [...this.code];
            const normalizedDigits = this.normalizeDigits(digits).slice(0, 4 - startIdx);

            normalizedDigits.split('').forEach((digit, offset) => {
                nextCode[startIdx + offset] = digit;
            });

            this.code = nextCode;
            this.emitCode();

            const nextEmptyIdx = this.code.findIndex((digit) => !digit);
            const lastFilledIdx = Math.min(startIdx + normalizedDigits.length, 3);
            this.focusInput(nextEmptyIdx === -1 ? lastFilledIdx : nextEmptyIdx);
        },
        handleInput (event, idx) {
            const digits = this.normalizeDigits(event.target.value);

            if (!digits) {
                this.code[idx] = '';
                event.target.value = '';
                this.emitCode();
                return;
            }

            this.fillDigits(digits, idx);
        },
        handlePaste (event, idx) {
            event.preventDefault();

            const digits = this.normalizeDigits(event.clipboardData?.getData('text'));
            const startIdx = digits.length >= 4 ? 0 : idx;

            if (digits) {
                this.fillDigits(digits, startIdx);
            }
        },
        handleKeyDown (event, idx) {
            if (event.code !== 'Backspace') {
                return;
            }

            event.preventDefault();

            if (this.code[idx]) {
                this.code[idx] = '';
                this.emitCode();
                this.focusInput(idx);
                return;
            }

            if (idx > 0) {
                this.code[idx - 1] = '';
                this.emitCode();
                this.focusInput(idx - 1);
            }
        },
    }
}
</script>

<style>

</style>
